import { render } from "./AirportsComponent.vue?vue&type=template&id=d6217d96&scoped=true"
import script from "./AirportsComponent.vue?vue&type=script&lang=js"
export * from "./AirportsComponent.vue?vue&type=script&lang=js"

import "./AirportsComponent.vue?vue&type=style&index=0&id=d6217d96&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6217d96"]])

export default __exports__